import React from "react";
import { Table, Button, Popup, Header } from "semantic-ui-react";
import TablaAcciones from "./filaColegios/TablaAcciones";
import Contactos from "./filaColegios/Contactos";
import EstadoVenta from "./filaColegios/EstadoVenta";

const botones = [
  {
    key: 0,
    name: "correo",
    icon: "at",
    text: "Correo Enviado",
    color: false,
    contacto: true,
    accionable: false,
    contador: true
  },
  {
    key: 1,
    name: "telefono",
    icon: "phone",
    text: "Llamada realizada",
    color: false,
    contacto: true,
    accionable: false,
    contador: true
  },
  {
    key: 2,
    name: "visita",
    icon: "travel",
    text: "Visita realizada",
    color: false,
    contacto: true,
    accionable: false,
    contador: false
  },
  {
    key: 3,
    name: "externo",
    icon: "external",
    text: "Contacto externo",
    color: false,
    contacto: true,
    accionable: false,
    contador: false
  },
  {
    key: 4,
    name: "tarea",
    icon: "tasks",
    text: "Crear nueva Tarea",
    color: true,
    contacto: false,
    accionable: true,
    contador: false
  },
  {
    key: 5,
    name: "cita",
    icon: "add to calendar",
    text: "Crear nueva Cita",
    color: true,
    contacto: false,
    accionable: true,
    contador: false
  },
  {
    key: 6,
    name: "contacto",
    icon: "add user",
    text: "Añadir nueva persona de contacto",
    color: true,
    contacto: false,
    accionable: true,
    contador: false
  }
];

class FilaColegios extends React.Component {
  state = { visible: false };

  handleButtonClick = (e, { name, accionable }) => {
    this.setState(state => ({ visible: !state.visible }));

    accionable === "true" &&
      this.props.handleButtonClick({
        idColegio: this.props.colegio.idColegio,
        opcion: name
      });
  };

  handleClose = () => this.setState({ visible: false });

  handleChangeEstadoVenta = estado =>
    this.props.handleChangeEstado({
      estado,
      idColegio: this.props.colegio.idColegio
    });

  renderEstadoVenta = colegio => (
    <Popup
      hoverable
      trigger={
        <Table.Cell textAlign="center" style={{ cursor: "pointer" }}>
          {colegio.estadoVenta}
        </Table.Cell>
      }
    >
      <Header as="h4" content="Estado general de la Venta" />
      <EstadoVenta
        estado={colegio.estadoVenta}
        handleChangeEstadoVenta={this.handleChangeEstadoVenta}
      />
    </Popup>
  );

  renderActionButtons = colegio =>
    botones.map(boton => (
      <Popup
        key={boton.key}
        hoverable
        position="top right"
        trigger={
          <Button
            circular
            size="tiny"
            icon={boton.icon}
            accionable={`${boton.accionable}`}
            name={boton.name}
            onClick={this.handleButtonClick}
            color={
              !boton.color
                ? null
                : (colegio.hasContactos && boton.name === "contacto") ||
                  (colegio.hasTareas && boton.name === "tarea") ||
                  (colegio.hasCitas && boton.name === "cita")
                  ? "green"
                  : null
            }
          />
        }
        onClose={this.handleClose}
      >
        <Header as="h4" content={boton.text} />
        {boton.contacto &&
          this.state.visible && (
            <Contactos tipo={boton.name} colegio={colegio} />
          )}
      </Popup>
    ));

  formatFechaCita = fecha => new Date(fecha).toLocaleString();

  render() {
    const { colegio } = this.props;

    return (
      <Table.Row verticalAlign="top">
        <Table.Cell content={colegio.nombreColegio} collapsing />
        <Table.Cell content={colegio.localidad} collapsing />
        <Table.Cell content={colegio.provincia} collapsing />
        <Table.Cell textAlign="center">
          <TablaAcciones idColegio={colegio.idColegio} />
        </Table.Cell>

        {this.renderEstadoVenta(colegio)}

        <Table.Cell
          content={
            colegio.citaVenta ? this.formatFechaCita(colegio.citaVenta) : "-"
          }
          collapsing
        />
        <Table.Cell content={colegio.usuario || "-"} collapsing />
        <Table.Cell collapsing textAlign="center">
          {this.renderActionButtons(colegio)}
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default FilaColegios;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/tablaColegios/FilaColegios.jsx